/**
 * Die echte Multi-Bowl-Bildserie von Hotty BBQ aus dem Product Studio:
 * drei Handyfotos als Referenz und drei visuell geprüfte Ergebnisse.
 *
 * Eine Quelle fuer `ProductSerieDemo` (Ablauf-Animation) und die Output-Wall
 * der Startseite — vorher lagen die Dateinamen nur in der Demo-Komponente.
 *
 * Product-Studio-Laeufe schreiben keine `dam_assets`-Zeile (siehe
 * docs/AI_DISCLOSURE_PLAN.md, Storage-Inventur), deshalb stehen hier die
 * Storage-Pfade statt Asset-IDs.
 */
const PRODUCT_IMAGE_BASE =
  "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/product-images";
const PRODUCT_STUDIO_BASE =
  "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/generated-images/product-studio";

/** Hotty BBQ (DACH) · Produkt „Multi-Bowl". */
const SERIE_PRODUCT_PATH = "4618aa49-35eb-4013-aca4-769328778e1b/2f9402e7-5921-4f43-8c5a-5594cdc42899";

/** Die drei Handyfotos, die in den Lauf gegeben wurden. */
export const PRODUCT_STUDIO_INPUTS: readonly string[] = [
  `${PRODUCT_IMAGE_BASE}/${SERIE_PRODUCT_PATH}/photo-2.jpg`,
  `${PRODUCT_IMAGE_BASE}/${SERIE_PRODUCT_PATH}/photo-1.jpg`,
  `${PRODUCT_IMAGE_BASE}/${SERIE_PRODUCT_PATH}/photo-0.jpg`,
];

/** Public selection reviewed against the three references on 2026-09-05.
 * Excludes incorrect bowl/grater construction, including a duplicated sieve.
 * See docs/START_ASSET_REVIEW_2026-09-05.md before expanding this selection.
 */
export const PRODUCT_STUDIO_OUTPUTS: readonly string[] = [
  "d0536665-7f40-44d1-b0c6-c91d7e139e76.jpg",
  "2e87c60a-1f27-483d-9f4a-6e34fabbaca4.jpg",
  "3954985d-252c-40d0-8aa4-1c572a2da847.jpg",
].map((file) => `${PRODUCT_STUDIO_BASE}/${file}`);
